"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
exports.__esModule = true;
exports["default"] = void 0;
var _regenerator = _interopRequireDefault(require("@babel/runtime/regenerator"));
var _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime/helpers/asyncToGenerator"));
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _assertThisInitialized2 = _interopRequireDefault(require("@babel/runtime/helpers/assertThisInitialized"));
var _inheritsLoose2 = _interopRequireDefault(require("@babel/runtime/helpers/inheritsLoose"));
var _taggedTemplateLiteralLoose2 = _interopRequireDefault(require("@babel/runtime/helpers/taggedTemplateLiteralLoose"));
var _entries2 = _interopRequireDefault(require("lodash/entries"));
var _flattenDeep2 = _interopRequireDefault(require("lodash/flattenDeep"));
var _find2 = _interopRequireDefault(require("lodash/find"));
var _react = _interopRequireWildcard(require("react"));
var _reactApollo = require("react-apollo");
var _graphqlTag = _interopRequireDefault(require("graphql-tag"));
var _mmcDataUtilities = _interopRequireDefault(require("@mmc-tools/mmc-data-utilities"));
var _aboveTheFoldOnlyServerRender = require("above-the-fold-only-server-render");
var _editorialDocument = require("@mmc/editorial-document");
var _miniDealerLocator = require("@mmc/mini-dealer-locator");
var _homepageCarSelector = require("@mmc/homepage-car-selector");
var _textBlock = require("@mmc/text-block");
var _commonRichText = require("@mmc/common-rich-text");
var _ctaRow = require("@mmc/cta-row");
var _commonCta = require("@mmc/common-cta");
var _reactRouter = require("react-router");
var _reactRedux = require("react-redux");
var _mmcVehicleCodeUtility = _interopRequireWildcard(require("@mmc-tools/mmc-vehicle-code-utility"));
var _commonI18n = require("@mmc/common-i18n");
var _commonLibs = require("@mmc/common-libs");
var _clsx4 = _interopRequireDefault(require("clsx"));
var _constructedForm = _interopRequireDefault(require("../styles/constructed-form.css"));
var _checkboxes = _interopRequireDefault(require("./checkboxes"));
var _datePicker = _interopRequireDefault(require("./date-picker"));
var _pastDatePicker = _interopRequireDefault(require("./past-date-picker"));
var _multiselect = _interopRequireDefault(require("./multiselect"));
var _radioButtons = _interopRequireDefault(require("./radio-buttons"));
var _selectMenu = _interopRequireDefault(require("./select-menu"));
var _textField = _interopRequireDefault(require("./text-field"));
var _formButton = _interopRequireDefault(require("./form-button"));
var _errorMessage = _interopRequireDefault(require("./error-message"));
var _vehicleTabs = _interopRequireDefault(require("./vehicle-tabs"));
var _constructedForm2 = _interopRequireDefault(require("./constructed-form.props/constructed-form.defaultProps"));
var _constructedForm3 = _interopRequireDefault(require("./constructed-form.props/constructed-form.propTypes"));
var _templateObject, _h, _input;
/* eslint-disable no-restricted-syntax */
/* eslint-disable class-methods-use-this */
/* eslint-disable react/no-array-index-key */
/**
 * ## ConstructedForm - component
 *
 * A component that uses incoming data to construct a form
 */
// We use the same default props for data and defaultData
// This keeps our PropTypes and DefaultProps objects nice and clean and non repeating
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0, _defineProperty2["default"])(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
var ObfuscateVehicleCode = new _mmcVehicleCodeUtility["default"](_mmcVehicleCodeUtility.VEHICLES_MAP);
var getVehicleByGuid = ObfuscateVehicleCode.getVehicleByGuid;
var LEAD_ID_COOKIE = 'LEAD_ID';
var dataUtils = new _mmcDataUtilities["default"]();
var shouldUseDataOrDefaultProps = dataUtils.shouldUseDataOrDefaultProps,
  handleNestedProp = dataUtils.handleNestedProp,
  formatAsMKSPath = dataUtils.formatAsMKSPath;
var generateRandomNumber = function generateRandomNumber() {
  return Math.floor(Math.random() * 999);
};

// Key value pairs for the form components
var FORM_ELEMENTS = {
  // eslint-disable-next-line
  TextField_1_0_0: _textField["default"],
  // eslint-disable-next-line
  EditorialDocument_1_0_0: _editorialDocument.EditorialDocument,
  select: _selectMenu["default"],
  checkbox: _checkboxes["default"],
  radio: _radioButtons["default"],
  date: _datePicker["default"],
  DatePickerField_1_0_0: _pastDatePicker["default"],
  multiselect: _multiselect["default"],
  // eslint-disable-next-line
  Form_Button_1_0_0: _formButton["default"],
  TextBlock_1_0_0: _textBlock.TextBlock,
  // eslint-disable-line
  MiniDealerLocator_1_0_0: _miniDealerLocator.MiniDealerLocator // eslint-disable-line
};
var SEND_FORM_DATA = (0, _graphqlTag["default"])(_templateObject || (_templateObject = (0, _taggedTemplateLiteralLoose2["default"])(["\n  mutation submitForm(\n    $path: String!\n    $market: String!\n    $language: String!\n    $form: FormInput!\n  ) {\n    submitForm(path: $path, market: $market, language: $language, form: $form) {\n      statusCode\n      errorMessages {\n        code\n        message\n        fieldName\n      }\n    }\n  }\n"])));
var safeScrollDocument = function safeScrollDocument(desiredPosition) {
  var isIE11 = false;
  var isEdge = false;
  if (typeof document !== 'undefined' && typeof window !== 'undefined') {
    isIE11 = !!window.MSInputMethodContext && !!document.documentMode; // eslint-disable-line
    if (window.navigator) {
      isEdge = window.navigator.userAgent.indexOf('Edge') > -1;
    }
  }
  if (isIE11) {
    document.documentElement.scrollTop = desiredPosition; // eslint-disable-line
  } else if (isEdge) {
    document.querySelector('body').scrollTop = desiredPosition; // eslint-disable-line
  } else if (typeof window !== 'undefined') {
    window.scrollTo({
      top: desiredPosition,
      left: 0,
      behavior: 'smooth'
    });
  }
};
var ConstructedForm = /*#__PURE__*/function (_React$Component) {
  (0, _inheritsLoose2["default"])(ConstructedForm, _React$Component);
  ConstructedForm.resourceType = function resourceType() {
    return 'Constructed_Form_1_0_0';
  };
  function ConstructedForm(props) {
    var _this;
    _this = _React$Component.call(this, props) || this;
    _this.getCookie = function (name) {
      var _document$cookie$matc;
      return (_document$cookie$matc = document.cookie.match(new RegExp("(^| )" + name + "=([^;]+)"))) == null ? void 0 : _document$cookie$matc.at(2);
    };
    var data = props.data,
      defaultData = props.defaultData;
    var componentData = shouldUseDataOrDefaultProps(data, defaultData);
    componentData.formComponents = [].concat(componentData.formComponents, _this.getPrefixParamsElements());
    _this.formRef = /*#__PURE__*/(0, _react.createRef)(null);
    _this.state = {
      componentData: componentData,
      formData: _this.generateInitialData(componentData.formComponents),
      formError: [],
      submitted: false,
      mutationError: false,
      mutationSuccess: false,
      isGhostSubmission: false
    };
    _this.publishFormSubmissionToDataLayer = _this.publishFormSubmissionToDataLayer.bind((0, _assertThisInitialized2["default"])(_this));
    _this.publishFormCompletedToDataLayer = _this.publishFormCompletedToDataLayer.bind((0, _assertThisInitialized2["default"])(_this));
    _this.formSubmit = _this.formSubmit.bind((0, _assertThisInitialized2["default"])(_this));
    _this.handleFieldChange = _this.handleFieldChange.bind((0, _assertThisInitialized2["default"])(_this));
    _this.validateAllConstraints = _this.validateAllConstraints.bind((0, _assertThisInitialized2["default"])(_this));
    _this.updateErrors = _this.updateErrors.bind((0, _assertThisInitialized2["default"])(_this));
    _this.checkRequired = _this.checkRequired.bind((0, _assertThisInitialized2["default"])(_this));
    _this.handleClickRegisterAgain = _this.handleClickRegisterAgain.bind((0, _assertThisInitialized2["default"])(_this));
    _this.leadTrackingRef = /*#__PURE__*/_react["default"].createRef();
    _this.carSelectorData = _this.getComponentData(_homepageCarSelector.HomepageCarSelector.resourceType());
    _this.hasHoneyPot = _this.hasHoneyPot.bind((0, _assertThisInitialized2["default"])(_this));
    _this.setGhostSubmission = _this.setGhostSubmission.bind((0, _assertThisInitialized2["default"])(_this));
    return _this;
  }
  var _proto = ConstructedForm.prototype;
  _proto.componentDidMount = function componentDidMount() {
    var _this$props = this.props,
      market = _this$props.config.market,
      currentPath = _this$props.currentPath,
      data = _this$props.data;
    var leadIdIncluded = document.cookie.includes(LEAD_ID_COOKIE);
    this.addAdditionalConstraints(data);
    if (!leadIdIncluded) {
      document.cookie = LEAD_ID_COOKIE + "=" + (Date.now() + generateRandomNumber()) + "; SameSite=Strict; Path=/";
    }
    var isES = market.toLowerCase() === 'es';
    var isPT = market.toLowerCase() === 'pt';
    var isFI = market.toLowerCase() === 'fi';
    var isRO = market.toLowerCase() === 'ro';
    if (typeof window !== 'undefined' && window.dataLayer && (isES || isPT || isFI)) {
      var formComponents = data.formComponents;
      window.dataLayer = window.dataLayer || [];
      if (data.leadFormType.toLowerCase() === 'contact-us') {
        var firstReason = formComponents.find(function (fields) {
          return fields.hasOwnProperty('fieldName') ? ['enquiry', 'consulta', 'yhteydenoton-aihe'].includes(fields.fieldName.toLowerCase()) : false;
        }).options[0].label;
        var formData = this.state.formData;
        var formDataFlatten = this.flattenArray(formData);
        window.dataLayer.push({
          event: 'contact_form_view',
          // The third party script (https://cdn.evgnet.com/beacon/astaramobilitysl/portugal/scripts/evergage.min.js) was trying to access within "data"
          data: {
            comp_page: {
              name_form: null,
              name_form_sha: null,
              phone_form: null,
              phone_form_sha: null,
              email_form: null,
              email_form_sha: null,
              contact_reason: firstReason ? firstReason.toLowerCase() : null,
              vehicle_type: 'car',
              brand: 'mitsubishi',
              product_condition: 'new',
              model: null,
              dealer_name: formDataFlatten.dealer && formDataFlatten.dealer.split('|')[2] ? formDataFlatten.dealer.split('|')[2].toLowerCase() : null,
              gender: null
            }
          },
          // but this is how Astara mentioned in doc so this
          // would be the fail-safe
          comp_page: {
            name_form: null,
            name_form_sha: null,
            phone_form: null,
            phone_form_sha: null,
            email_form: null,
            email_form_sha: null,
            contact_reason: firstReason ? firstReason.toLowerCase() : null,
            vehicle_type: 'car',
            brand: 'mitsubishi',
            product_condition: 'new',
            model: null,
            dealer_name: formDataFlatten.dealer ? formDataFlatten.dealer.split('|')[2].toLowerCase() : null,
            gender: null
          }
        });
      }
      if (data.leadFormType.toLowerCase() === 'book-a-test-drive') {
        var _formData = this.state.formData;
        var _formDataFlatten = this.flattenArray(_formData);
        var model = this.carSelectorData && this.carSelectorData.productTile.find(function (e) {
          return e.code + "_" + e.year === _formDataFlatten.vehicle;
        });
        window.dataLayer.push({
          event: 'test_drive_request_view',
          comp_product: {
            vehicle_type: 'car',
            brand: 'mitsubishi',
            product_condition: 'new',
            model: model && model.name ? model.name.toLowerCase() : _formDataFlatten['chosen-test-drive-vehicle'] && _formDataFlatten['chosen-test-drive-vehicle'].toLowerCase() || null,
            version: null,
            fuel_type: null,
            dealer_name: _formDataFlatten.dealer && _formDataFlatten.dealer.split('|')[2] ? _formDataFlatten.dealer.split('|')[2].toLowerCase() : null,
            name_form: null,
            name_form_sha: null,
            phone_form: null,
            phone_form_sha: null,
            email_form: null,
            email_form_sha: null,
            step: '0/2'
          }
        });
      }
      if (isES && data.leadFormType.toLowerCase() === 'book-a-service') {
        var _formData2 = this.state.formData;
        var _formDataFlatten2 = this.flattenArray(_formData2);
        var allFormComp = formComponents.reduce(function (acc, curr) {
          if ('columns' in curr && curr.columns.length) {
            var arr = curr.columns.reduce(function (accc, currr) {
              // eslint-disable-next-line no-param-reassign
              accc = [].concat(accc, currr.components);
              return accc;
            }, []);
            // eslint-disable-next-line no-param-reassign
            acc = [].concat(acc, arr);
          } else {
            acc.push(curr);
          }
          return acc;
        }, []);
        var modelfield = allFormComp.find(function (i) {
          return i.fieldName === 'modelo';
        });
        var modelName = modelfield && modelfield.hasOwnProperty('options') && modelfield.options.length && modelfield.options[0].label ? modelfield.options[0].label.toLowerCase() : null;
        window.dataLayer.push({
          event: 'maintenance_request_view',
          comp_product: {
            vehicle_type: 'car',
            brand: 'mitsubishi',
            product_condition: 'new',
            model: modelName,
            version: null,
            fuel_type: null,
            dealer_name: _formDataFlatten2.dealer ? _formDataFlatten2.dealer.toLowerCase() : null,
            name_form: null,
            name_form_sha: null,
            phone_form: null,
            phone_form_sha: null,
            email_form: null,
            email_form_sha: null,
            step: '0/2'
          }
        });
      }
    }
    if (typeof window !== 'undefined' && window.dataLayer && isRO) {
      if (['book-a-test-drive', 'book-a-service'].includes(data.leadFormType.toLowerCase())) {
        window.dataLayer = window.dataLayer || [];
        window.dataLayer.push({
          event: 'form_view',
          form_name: data.leadFormType && data.leadFormType.toLowerCase() === 'book-a-test-drive' ? 'test drive' : data.leadFormType && data.leadFormType.toLowerCase() === 'book-a-service' ? 'service' : null
        });
      }
    }
    var componentData = this.state.componentData;
    if (componentData.showRecaptcha) {
      this.handleCaptchaScript(componentData.recaptchaSiteKey);
    }
  };
  _proto.addAdditionalConstraints = function addAdditionalConstraints(data) {
    var formComponents = data.formComponents;
    /* Adding maxlength constraint for textfields */
    formComponents.map(function (element, idx) {
      if (element.resourceType === 'FormColumnControl_1_0_0') {
        var _element$columns;
        element == null ? void 0 : (_element$columns = element.columns) == null ? void 0 : _element$columns.map(function (curr) {
          var _curr$components;
          curr == null ? void 0 : (_curr$components = curr.components) == null ? void 0 : _curr$components.map(function (comp) {
            if (comp.resourceType === 'TextField_1_0_0' && comp.maxLength > 0) {
              var constraints = comp.constraints,
                maxLength = comp.maxLength,
                constraintMessage = comp.constraintMessage;
              constraints.push({
                constraintType: 'maxLength',
                regex: "^.{0," + maxLength + "}$",
                validationMessage: constraintMessage
              });
            }
          });
        });
      }
    });
  };
  _proto.handleCaptchaScript = function handleCaptchaScript(value) {
    var script = document.createElement('script');
    script.src = "https://www.google.com/recaptcha/api.js?render=" + value;
    script.async = true;
    document.body.appendChild(script);
  };
  _proto.handleFieldChange = function handleFieldChange(position, value, fieldName) {
    var _this2 = this;
    if (fieldName === void 0) {
      fieldName = '';
    }
    this.setState(function (state) {
      var updateFormData = _this2.makeUpdatedObject(state.formData);
      return {
        formData: updateFormData(position, 'value', value)
      };
    });
    var _this$props2 = this.props,
      market = _this$props2.config.market,
      data = _this$props2.data;
    if (market.toLowerCase() === 'ro' && typeof window !== 'undefined' && window.dataLayer) {
      if (['book-a-test-drive', 'book-a-service'].includes(data.leadFormType.toLowerCase())) {
        if (fieldName) {
          if (window.dataLayer.filter(function (e) {
            return e.event === 'form_start';
          }).length === 0 || window.dataLayer.filter(function (e) {
            return e.event === 'form_start';
          }).reduce(function (acc, curr) {
            return acc && !curr.hasOwnProperty('form_name');
          }, true)) {
            window.dataLayer = window.dataLayer || [];
            window.dataLayer.push({
              event: 'form_start',
              form_name: data.leadFormType && data.leadFormType.toLowerCase() === 'book-a-test-drive' ? 'test drive' : data.leadFormType.toLowerCase() === 'book-a-service' ? 'service' : null
            });
          }
          if (fieldName.toLowerCase() === 'chosen-test-drive-vehicle' || fieldName.toLowerCase() === 'vehicle-dropdown' || fieldName.toLowerCase() === 'dealer-info') {
            var newTimer = setTimeout(function () {
              var formData = _this2.state.formData;
              var formDataFlatten = _this2.flattenArray(formData);
              window.dataLayer = window.dataLayer || [];
              var carTypeFieldValue = formDataFlatten['chosen-test-drive-vehicle'] || formDataFlatten['vehicle-dropdown'] || null;
              var dealerFieldValue = formDataFlatten.dealer ? formDataFlatten.dealer.split('|')[2] : null;
              window.dataLayer.push({
                event: 'form_interaction',
                form_name: data.leadFormType && data.leadFormType.toLowerCase() === 'book-a-test-drive' ? 'test drive' : data.leadFormType && data.leadFormType.toLowerCase() === 'book-a-service' ? 'service' : null,
                form_field_car_type: carTypeFieldValue,
                form_field_geo_location: dealerFieldValue
              });
              clearTimeout(newTimer);
            }, 0);
          }
        }
      }
    }
  };
  _proto.handleClickRegisterAgain = function handleClickRegisterAgain() {
    var data = this.props.data;
    var formId = handleNestedProp(data, 'data.leadFormType');
    var initialFormData = this.generateInitialData(data.formComponents);
    var element = document.getElementById(formId);
    var headerOffset = 120;
    var elementPosition = element.getBoundingClientRect().top;
    if (typeof window !== 'undefined') {
      var offsetPosition = elementPosition + window.pageYOffset - headerOffset;
      window.scrollTo({
        top: offsetPosition,
        behavior: 'smooth'
      });
    }
    this.setState({
      formData: initialFormData,
      submitted: false
    });
  };
  _proto.getConstraints = function getConstraints(position, formComponents) {
    var i = position[0],
      j = position[1],
      k = position[2];
    return position.length === 1 ? formComponents[i].constraints : formComponents[i].columns[j].components[k].constraints;
  };
  _proto.getFileNameFromLink = function getFileNameFromLink(link) {
    return link && link.length > 0 ? link[0].slice(link[0].lastIndexOf('/') + 1) : '';
  };
  _proto.getActiveOption = function getActiveOption(options) {
    return options.filter(function (option) {
      return option.active === true;
    }).map(function (option) {
      return option.key;
    });
  };
  _proto.getURLInfo = function getURLInfo() {
    var _window = window,
      location = _window.location;
    if (typeof location !== 'undefined') {
      var protocol = location.protocol,
        host = location.host; // eslint-disable-line
      return {
        protocol: protocol,
        host: host
      };
    }
    return {};
  };
  _proto.getComponentData = function getComponentData(resourceType) {
    var componentData = this.state.componentData;
    return (0, _find2["default"])(componentData.formComponents, {
      resourceType: resourceType
    });
  };
  _proto.setSubmitted = function setSubmitted(value) {
    this.setState({
      submitted: value
    });
  };
  _proto.getValue = function getValue(element) {
    return Object.prototype.hasOwnProperty.call(element, 'choiceFieldType') ? this.getActiveOption(element.options) : this.isQueryParamField(element.fieldName, element.value);
  };
  _proto.getEditorialValue = function getEditorialValue(element) {
    return handleNestedProp(element, 'element.columns.0.selectStyle') === 'downloadPDF' ? ' ' : [{
      link: {
        url: handleNestedProp(element, 'element.columns.0.link.url')
      },
      image: {
        image: handleNestedProp(element, 'element.columns.0.image.image'),
        altText: handleNestedProp(element, 'element.columns.0.image.altText')
      },
      description: {
        mainHeading: handleNestedProp(element, 'element.columns.0.description.mainHeading')
      }
    }];
  };
  _proto.getPrefixParamsElements = function getPrefixParamsElements() {
    var location = this.props.location;
    var queryParams = (location == null ? void 0 : location.query) || {};
    var CF_PREFIX = 'cf_';
    var prefixParamsElements = Object.keys(queryParams).filter(function (key) {
      return key.startsWith(CF_PREFIX);
    }).map(function (key) {
      return {
        name: key,
        value: queryParams[key],
        type: 'text',
        isRequired: false
      };
    });
    return prefixParamsElements;
  };
  _proto.getInquiryForm = function getInquiryForm(formData) {
    return formData.filter(function (form) {
      return form.fieldName === 'inquiry';
    });
  };
  _proto.getSelectedInquiry = function getSelectedInquiry(formObject) {
    var selectedInquiry = '';
    if (formObject && formObject.length > 0) {
      selectedInquiry = formObject[0];
      var _selectedInquiry$valu = selectedInquiry.value;
      selectedInquiry = _selectedInquiry$valu[0];
    }
    return selectedInquiry;
  };
  _proto.updateHasErrors = function updateHasErrors(errors, fn) {
    if (fn === void 0) {
      fn = function fn() {
        return null;
      };
    }
    this.setState({
      formError: errors
    }, fn());
  };
  _proto.updateErrors = function updateErrors(position, errors) {
    var _this3 = this;
    this.setState(function (state) {
      var updateFormData = _this3.makeUpdatedObject(state.formData);
      return {
        formData: updateFormData(position, 'errors', errors)
      };
    }, function () {
      var _this3$state = _this3.state,
        submitted = _this3$state.submitted,
        mutationError = _this3$state.mutationError,
        formError = _this3$state.formError;
      if (submitted || mutationError) {
        var errorsArray = formError;
        var updatedErrors = position && position.length === 1 ? [].concat(errorsArray.slice(0, position[0]), [_this3.checkErrors(undefined, errors)], errorsArray.slice(position[0] + 1)) : [].concat(errorsArray.slice(0, position[0]), [_this3.updatedNestedErrorData(errorsArray.slice(position[0], position[0] + 1)[0], position, errors)], errorsArray.slice(position[0] + 1));
        _this3.updateHasErrors(updatedErrors, mutationError ? _this3.setSubmitted(false) : undefined);
      }
    });
  };
  _proto.hasValueReturnArray = function hasValueReturnArray(val) {
    return val === '' ? '' : [val];
  }

  // This enormous function takes the data from AEM and breaks it down into a state that can be programmatically updated and that can also be rendered how it is intended
  ;
  _proto.generateInitialData = function generateInitialData(formComponents) {
    var _this4 = this;
    var location = this.props.location;
    return formComponents.map(function (element, idx) {
      return element.resourceType === 'FormColumnControl_1_0_0' ? element.columns.reduce(function (acc, curr, id2) {
        return [].concat(acc, [curr.components.reduce(function (comps, comp, id3) {
          var value = _this4.getValue(comp);
          var defaultValue = comp == null ? void 0 : comp.defaultValue;
          if (comp.resourceType === 'EditorialDocument_1_0_0') {
            value = handleNestedProp(comp, 'comp.columns.0.selectStyle') === 'downloadPDF' ? ' ' : [{
              link: {
                url: handleNestedProp(comp, 'comp.columns.0.link.url')
              },
              image: {
                image: handleNestedProp(comp, 'comp.columns.0.image.image'),
                altText: handleNestedProp(comp, 'comp.columns.0.image.altText')
              },
              description: {
                mainHeading: handleNestedProp(comp, 'comp.columns.0.description.mainHeading')
              }
            }];
            return [].concat(comps, [{
              fieldName: 'editorialDocument',
              value: value,
              type: 'radio',
              required: true,
              pos: [idx],
              errors: []
            }]);
          }
          return [].concat(comps, [{
            fieldName: comp.fieldName ? comp.fieldName : comp.name,
            value: value || defaultValue || '',
            type: comp.inputType || comp.choiceFieldType || comp.type,
            required: comp.isRequired,
            pos: [idx, id2, id3],
            errors: [],
            showWhenOptionMatches: comp.showWhenOptionMatches
          }]);
        }, [])]);
      }, []) : function () {
        var value = _this4.getValue(element);
        var defaultValue = element == null ? void 0 : element.defaultValue;
        if (element.resourceType === 'EditorialDocument_1_0_0') {
          value = _this4.getEditorialValue(element);
          return {
            fieldName: 'editorialDocument',
            value: value,
            type: 'radio',
            required: true,
            pos: [idx],
            errors: []
          };
        }
        if (element.resourceType === 'MiniDealerLocator_1_0_0') {
          element.isWrapped = true; /* Since the mini dealer comp is used inside constructed form wrapper */
          // eslint-disable-next-line no-param-reassign
          element.multiSelect = element.allowMultiDealersSelectionforSubmitForm;
          var fieldName = element.multiSelect ? 'dealers' : 'dealer';
          return {
            fieldName: fieldName,
            value: _this4.getValue({
              fieldName: fieldName
            }),
            type: element.multiSelect ? 'checkbox' : 'radio',
            multiSelect: element.multiSelect,
            required: element.isRequired,
            pos: [idx],
            errors: []
          };
        }
        if (element.resourceType === 'TextBlock_1_0_0') {
          return {
            fieldName: 'text-block',
            value: 'exclude-from-the-submit',
            type: 'textBlock',
            required: false,
            pos: [idx],
            errors: []
          };
        }
        if (element.resourceType === 'CarSelector_1_0_0') {
          var queryParams = location.query || {};
          var encodedVehicleCode = _this4.hasValueReturnArray(_this4.getValue({
            fieldName: 'vehicle'
          }));
          var year = _this4.checkAndGetParam('year', queryParams);
          value = _this4.shouldDecode.apply(_this4, [_mmcVehicleCodeUtility.VEHICLES_MAP].concat(encodedVehicleCode)) ? [getVehicleByGuid.apply(void 0, encodedVehicleCode)] : encodedVehicleCode;
          return {
            fieldName: 'vehicle',
            value: year !== '' ? [value + "_" + year] : value,
            type: 'radio',
            required: true,
            pos: [idx],
            errors: []
          };
        }
        if (element.resourceType === 'DatePickerField_1_0_0') {
          return {
            fieldName: element.datePickerFieldName,
            value: value,
            type: element.inputType,
            required: element.datePickerFieldRequired,
            pos: [idx],
            errors: [],
            showWhenOptionMatches: element.showWhenOptionMatches
          };
        }
        return {
          fieldName: element.fieldName ? element.fieldName : element.name,
          value: value || defaultValue || '',
          type: element.inputType || element.choiceFieldType || element.type,
          required: element.isRequired,
          pos: [idx],
          errors: [],
          showWhenOptionMatches: element.showWhenOptionMatches
        };
      }();
    });
  }

  // A function to check if two arrays are the same (mostly)
  // It first checks if they have the same length, returns false if not
  // Then it filters over the first array, matches the current value against
  // the value at the same index of the second array provided
  ;
  _proto.isSameArray = function isSameArray(xs, ys) {
    return xs.length === ys.length ? xs.filter(function (x, i) {
      return x !== ys[i];
    }).length === 0 : false;
  };
  _proto.findNestedData = function findNestedData(fn) {
    return function (element, i, position) {
      if (position === void 0) {
        position = undefined;
      }
      return element.map(function (row, j) {
        return row.map(function (columnElement, k) {
          return fn(columnElement, position || [i, j, k]);
        });
      });
    };
  };
  _proto.updatedNestedErrorData = function updatedNestedErrorData(nestedArray, position, data) {
    var _this5 = this;
    return nestedArray.map(function (array1, i) {
      return i === position[1] ? array1.map(function (array2, j) {
        return (
          // eslint-disable-next-line
          j === position[2] ? _this5.checkErrors(undefined, data) : array2
        );
      }) : array1;
    });
  };
  _proto.checkAndUpdate = function checkAndUpdate(propertyToUpdate, value) {
    var _this6 = this;
    return function (element, position) {
      if (_this6.isSameArray(element.pos, position)) {
        var _objectSpread2;
        return _objectSpread(_objectSpread({}, element), {}, (_objectSpread2 = {}, _objectSpread2[propertyToUpdate] = value, _objectSpread2));
      }
      return element;
    };
  };
  _proto.makeUpdatedObject = function makeUpdatedObject(arrayToUpdate) {
    var _this7 = this;
    return function (position, propertyToUpdate, value) {
      var checkAndUpdateWithValue = _this7.checkAndUpdate(propertyToUpdate, value);
      var findDataAndUpdate = _this7.findNestedData(checkAndUpdateWithValue);
      return arrayToUpdate.map(function (element, i) {
        return Array.isArray(element) ? findDataAndUpdate(element, i, position) : checkAndUpdateWithValue(element, position);
      });
    };
  };
  _proto.validateConstraint = function validateConstraint(value, constraint) {
    if (!constraint || !constraint.regex) {
      return '';
    }
    var fieldRegex = new RegExp(constraint.regex, 'gm');
    return fieldRegex.test(value) && constraint ? '' : handleNestedProp(constraint, 'constraint.validationMessage');
  };
  _proto.validateAllConstraints = function validateAllConstraints(value, constraints) {
    var _this8 = this;
    return constraints ? constraints.map(function (constraint) {
      return _this8.validateConstraint(value, constraint);
    }) : '';
  };
  _proto.checkRequired = function checkRequired(value, isRequired) {
    if (value === ' ' && isRequired === ' ') {
      return '';
    }
    return !this.hasValue(value) && Boolean(isRequired) ? 'requiredMessage' : '';
  };
  _proto.checkForDocumentCard = function checkForDocumentCard(formData, theme) {
    var _formData$filter = formData.filter(function (data) {
        return data.fieldName === 'editorialDocument';
      }),
      editorialDocumentData = _formData$filter[0];
    var _ref = editorialDocumentData || {},
      _ref$value = _ref.value,
      value = _ref$value === void 0 ? [] : _ref$value;
    return value.length > 0 && /*#__PURE__*/_react["default"].createElement(_editorialDocument.EditorialDocument, {
      theme: theme,
      customCards: value,
      cardType: "download",
      linkClasses: [_constructedForm["default"].brochureLink]
    });
  };
  _proto.hasValue = function hasValue(value) {
    if (value === null) {
      return false;
    }
    if (typeof value === 'string') {
      return value !== '' && value !== ' ';
    }
    if (typeof value === 'object') {
      return value.length > 0 && value[0] !== '';
    }
    return value && typeof value !== 'undefined';
  };
  _proto.checkErrors = function checkErrors(required, constraintErrors) {
    if (required) {
      return 'error';
    }
    if (constraintErrors.filter(function (err) {
      return err !== '';
    }).length > 0) {
      return 'error';
    }
    return null;
  };
  _proto.checkAndGetParam = function checkAndGetParam(paramName, allParams) {
    return paramName in allParams ? "" + allParams[paramName] : '';
  };
  _proto.isQueryParamField = function isQueryParamField(fieldName, value) {
    return fieldName === 'chosen-test-drive-vehicle' || fieldName === 'dealer' || fieldName === 'vehicle' || fieldName === 'accessory' ? this.makeLocationQueryValue(fieldName) : value;
  };
  _proto.shouldDecode = function shouldDecode(map, value) {
    return map.filter(function (el) {
      return el.guid === value;
    }).length > 0;
  };
  _proto.makeLocationQueryValue = function makeLocationQueryValue(field) {
    var location = this.props.location;
    var queryParams = location.query || {};
    var paramToGet = '';
    switch (field) {
      case 'chosen-test-drive-vehicle':
        paramToGet = 'name';
        break;
      case 'dealer':
        paramToGet = 'dealerAddress';
        break;
      case 'vehicle':
        paramToGet = 'vehicle';
        break;
      case 'accessory':
        paramToGet = 'accessory';
        break;
      default:
        break;
    }
    return this.checkAndGetParam(paramToGet, queryParams);
  };
  _proto.validateSubmit = function validateSubmit(formComponents) {
    var _this9 = this;
    var formData = this.state.formData;
    var inquiryForm = this.getInquiryForm(formData);
    var selectedInquiry = this.getSelectedInquiry(inquiryForm);
    return function (element, position) {
      var constraintErrors = [];

      // When input element has an element in showWhenOptionMatches array and
      // if it isn't matched with the current selectedInquiry, it doesn't check required constraint.
      var required = element.showWhenOptionMatches && element.showWhenOptionMatches.length > 0 && !element.showWhenOptionMatches.includes(selectedInquiry) ? '' : _this9.checkRequired(handleNestedProp(element, 'element.value'), handleNestedProp(element, 'element.required'));
      if (required === 'requiredMessage' || _this9.hasValue(element.value)) {
        constraintErrors = [].concat(_this9.validateAllConstraints(element.value, _this9.getConstraints(position, formComponents)));
      }
      _this9.updateErrors(position, [required].concat(constraintErrors));
      return _this9.checkErrors(required, constraintErrors);
    };
  };
  _proto.checkCompType = function checkCompType(el) {
    if (el.resourceType === 'ChoiceType_1_0_0') {
      return el.choiceFieldType;
    }
    if (el.resourceType === 'TextField_1_0_0' && el.inputType === 'date') {
      return el.inputType;
    }
    return el.resourceType;
  };
  _proto.dealerSubmitName = function dealerSubmitName(i) {
    var dealerFieldNames = ['dealer', 'internal_dealer_id', 'dealername', 'dealeraddress', 'dealerphone', 'dealerurl'];
    return dealerFieldNames[i];
  };
  _proto.makeDealerData = function makeDealerData(el) {
    var _this10 = this;
    var _this$props3 = this.props,
      data = _this$props3.data,
      market = _this$props3.config.market;
    var formType = handleNestedProp(data, 'graphQLFormData.leadFormType');
    this.setState(function (state) {
      var temp = state.componentData;
      temp.selectedDealer = el.value;
      return {
        componentData: temp
      };
    });
    return el.value === '' ? [] : el.value[0].split('|').map(function (value, i) {
      if (market.toLowerCase() === 'nl' && formType.toLowerCase() === 'offerte' && _this10.dealerSubmitName(i) === 'dealername') {
        return {
          fieldName: 'dealername',
          type: 'string',
          value: 'exclude-from-the-submit'
        };
      }
      return _this10.makeFormObject({
        fieldName: _this10.dealerSubmitName(i),
        value: value.trim()
      });
    });
  };
  _proto.makeDealersData = function makeDealersData(el) {
    var data = [];
    if (Array.isArray(el.value)) {
      data = [this.makeFormObject({
        fieldName: 'dealers',
        value: el.value.map(function (item) {
          return item.split('|')[0];
        }).join('-') // `dealer1-dealer2`
      })];
    }
    this.setState(function (state) {
      var temp = state.componentData;
      temp.selectedDealer = el.value;
      return {
        componentData: temp
      };
    });
    return data;
  };
  _proto.formatPhoneNumber = function formatPhoneNumber(phoneNumberString) {
    var cleaned = ("" + phoneNumberString).replace(/\D/g, '');
    var match = cleaned.match(/^(1|)?(\d{3})(\d{3})(\d{4})$/);
    if (match) {
      var intlCode = match[1] ? '+1 ' : '';
      return [intlCode, '(', match[2], ') ', match[3], '-', match[4]].join('');
    }
    return null;
  };
  _proto.makeDealerDetails = function makeDealerDetails(selectedDealer) {
    var _this11 = this;
    var dealerDetails = {};
    selectedDealer.split('|').forEach(function (value, i) {
      switch (i) {
        case 2:
          dealerDetails.dealerName = value.trim();
          break;
        case 3:
          dealerDetails.dealerAddress = value.trim().replace(', ', '\n');
          break;
        case 4:
          dealerDetails.dealerPhone = _this11.formatPhoneNumber(value.trim());
          break;
        case 5:
          dealerDetails.dealerUrl = value.trim();
          break;
        default:
          break;
      }
    });
    return dealerDetails;
  };
  _proto.makeEditorialDocumentObject = function makeEditorialDocumentObject(el) {
    return {
      fieldName: el.fieldName,
      type: 'string',
      value: el.value.map(function (cardData) {
        return cardData.description.mainHeading;
      }).join(',')
    };
  };
  _proto.makeVehicleObject = function makeVehicleObject(el) {
    var selectedCarCodeAndYear = this.checkAndStringify(el.value);
    var vehicleName = '';
    if (this.carSelectorData) {
      var vehicles = this.carSelectorData.productTile;
      if (vehicles !== ' ') {
        var selectedCarCode = selectedCarCodeAndYear.split('_')[0];
        var selectedVehicle = vehicles.find(function (vehicle) {
          return vehicle.code === selectedCarCode;
        });
        this.setState(function (state) {
          var temp = state.componentData;
          temp.selectedVehicle = selectedVehicle;
          return {
            componentData: temp
          };
        });
        vehicleName = selectedVehicle.name + " - ";
      }
    }
    return {
      fieldName: el.fieldName,
      type: 'string',
      value: "" + vehicleName + selectedCarCodeAndYear
    };
  };
  _proto.makeFormObject = function makeFormObject(el) {
    return {
      fieldName: el.fieldName,
      type: 'string',
      value: this.checkAndStringify(el.value)
    };
  };
  _proto.isFieldOfInterest = function isFieldOfInterest(element) {
    var returnObject = null;
    switch (element.fieldName) {
      case 'dealer':
        returnObject = this.makeDealerData(element);
        break;
      case 'dealers':
        returnObject = this.makeDealersData(element);
        break;
      case 'vehicle':
        returnObject = this.makeVehicleObject(element);
        break;
      case 'editorialDocument':
        returnObject = this.makeEditorialDocumentObject(element);
        break;
      default:
        returnObject = this.makeFormObject(element);
    }
    return returnObject;
  };
  _proto.addFormURLField = function addFormURLField(formData) {
    var location = this.props.location;
    // Get different parts of the url
    var urlParts = this.getURLInfo();

    // Get any campaign variables that are stored in our session cookie
    var cookieParams = {};
    if (document.cookie !== '') {
      // eslint-disable-line
      document.cookie.split('; ').forEach(function (cookieParam) {
        // eslint-disable-line
        if (cookieParam.includes('utm_') || cookieParam.includes(LEAD_ID_COOKIE)) {
          var cookieData = cookieParam.split('=');
          var cookieToUse = cookieData[0];
          var cookieToSwap = cookieData[1];
          if (cookieParams[cookieToUse] === undefined) {
            cookieParams[cookieToUse] = cookieToSwap;
          }
        }
      });
    }

    // Compile query params and cookie params into a new search string
    var compiledParams = _objectSpread(_objectSpread({}, cookieParams), location.query);
    var searchString = '';
    // eslint-disable-line
    searchString = (0, _entries2["default"])(compiledParams).map(function (_ref2) {
      var key = _ref2[0],
        value = _ref2[1];
      return key + "=" + value;
    }).join('&');
    if (searchString) searchString = "?" + searchString;

    // Concatenate url parts with updated search string
    var currentURL = urlParts.protocol + "//" + urlParts.host + location.pathname + searchString;
    return [].concat(formData, [this.makeFormObject({
      fieldName: 'leadFormURL',
      value: currentURL
    })]);
  };
  _proto.simplifyData = function simplifyData(rawData) {
    var _this12 = this;
    return rawData.reduce(function (acc, element) {
      return acc.concat(Array.isArray(element) ? element.map(function (column) {
        return column.map(function (obj) {
          return _this12.makeFormObject(obj);
        });
      }) : _this12.isFieldOfInterest(element));
    }, []);
  }

  // elements with this string as their value are to omitted from the submit
  ;
  _proto.removeExcludedData = function removeExcludedData(dataArray) {
    return dataArray.filter(function (el) {
      return el.value !== 'exclude-from-the-submit';
    });
  };
  _proto.checkAndStringify = function checkAndStringify(value) {
    return Array.isArray(value) ? value.join('|') : value;
  };
  _proto.mutationVariables = function mutationVariables(market, language, path, formData) {
    if (market === void 0) {
      market = 'language-masters';
    }
    if (language === void 0) {
      language = 'en';
    }
    if (path === void 0) {
      path = '';
    }
    var data = this.props.data;
    var formDescription = handleNestedProp(data, 'graphQLFormData.leadFormDescription');
    var componentData = this.state.componentData;
    var formType = handleNestedProp(data, 'graphQLFormData.leadFormType');
    var leadOfferCode = handleNestedProp(data, 'graphQLFormData.leadOfferCode');
    var vehicleYear = handleNestedProp(data, 'graphQLFormData.vehicleYear');
    var vehicleModel = handleNestedProp(data, 'graphQLFormData.vehicleModel');
    var leadFields = this.removeExcludedData((0, _flattenDeep2["default"])(this.addFormURLField(this.simplifyData(formData))));
    if (leadOfferCode && leadOfferCode !== ' ') {
      leadFields.push({
        fieldName: 'leadOfferCode',
        type: 'string',
        value: leadOfferCode
      });
    }
    if (vehicleYear && vehicleYear !== ' ') {
      leadFields.push({
        fieldName: 'vehicleYear',
        type: 'string',
        value: vehicleYear
      });
    }
    if (vehicleModel && vehicleModel !== ' ') {
      leadFields.push({
        fieldName: 'vehicleModel',
        type: 'string',
        value: vehicleModel
      });
    }
    if (componentData.showRecaptcha) {
      leadFields.push({
        fieldName: 'recaptchaResponse',
        type: 'string',
        value: componentData.recaptchaToken
      });
    }
    return {
      market: market,
      language: language,
      path: path,
      form: {
        leadFormType: formType,
        leadFormDescription: formDescription || formType,
        leadFields: leadFields
      }
    };
  };
  _proto.flattenArray = function flattenArray(inputArr) {
    var obj = {};
    this.recursion(0, inputArr, obj);
    return obj;
  };
  _proto.recursion = function recursion(index, inputArr, obj) {
    if (index >= inputArr.length) return;
    if (Array.isArray(inputArr[index])) {
      this.recursion(0, inputArr[index], obj);
    } else if (inputArr[index].fieldName) {
      // eslint-disable-next-line no-param-reassign
      obj[inputArr[index].fieldName.toLowerCase()] = inputArr[index].value && Array.isArray(inputArr[index].value) ? inputArr[index].value[0] : inputArr[index].value;
    }
    this.recursion(index + 1, inputArr, obj);
  };
  _proto.hash = /*#__PURE__*/function () {
    var _hash = (0, _asyncToGenerator2["default"])(/*#__PURE__*/_regenerator["default"].mark(function _callee(string) {
      var utf8, hashBuffer, hashArray, hashHex;
      return _regenerator["default"].wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              utf8 = new TextEncoder().encode(string);
              _context.next = 3;
              return crypto.subtle.digest('SHA-256', utf8);
            case 3:
              hashBuffer = _context.sent;
              hashArray = Array.from(new Uint8Array(hashBuffer));
              hashHex = hashArray.map(function (bytes) {
                return bytes.toString(16).padStart(2, '0');
              }).join('');
              return _context.abrupt("return", hashHex);
            case 7:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    }));
    function hash(_x) {
      return _hash.apply(this, arguments);
    }
    return hash;
  }();
  _proto.publishFormSubmissionToDataLayer = /*#__PURE__*/function () {
    var _publishFormSubmissionToDataLayer = (0, _asyncToGenerator2["default"])(/*#__PURE__*/_regenerator["default"].mark(function _callee2(hasErrors) {
      var _this$props4, market, data, formData, formDataFlatten, contactReasonSelected, model, customerName, _customerName, _formDataFlatten3, enhancedConvUserData, _model$vehicleModel, _model$baseModelCode, _formDataFlatten4, _model, mmscan_opt_in, dealer_opt_in, dataCollection;
      return _regenerator["default"].wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              if (hasErrors === void 0) {
                hasErrors = true;
              }
              _this$props4 = this.props, market = _this$props4.config.market, data = _this$props4.data;
              formData = this.state.formData;
              if (!((market.toLowerCase() === 'es' || market.toLowerCase() === 'pt' || market.toLowerCase() === 'fi') && typeof window !== 'undefined' && window.dataLayer)) {
                _context2.next = 70;
                break;
              }
              formDataFlatten = this.flattenArray(formData);
              window.dataLayer = window.dataLayer || [];
              if (!(data.leadFormType.toLowerCase() === 'contact-us')) {
                _context2.next = 27;
                break;
              }
              contactReasonSelected = null;
              if (formDataFlatten.enquiry) {
                contactReasonSelected = formDataFlatten.enquiry.toLowerCase();
              } else if (formDataFlatten.consulta) {
                contactReasonSelected = formDataFlatten.consulta.toLowerCase();
              } else if (formDataFlatten['yhteydenoton-aihe']) {
                contactReasonSelected = formDataFlatten['yhteydenoton-aihe'].toLowerCase();
              }
              _context2.t0 = window.dataLayer;
              _context2.t1 = (formDataFlatten.firstname + " " + formDataFlatten.lastname).toLowerCase();
              _context2.next = 13;
              return this.hash((formDataFlatten.firstname + " " + formDataFlatten.lastname).toLowerCase());
            case 13:
              _context2.t2 = _context2.sent;
              _context2.t3 = formDataFlatten.phonenumber;
              _context2.next = 17;
              return this.hash(formDataFlatten.phonenumber);
            case 17:
              _context2.t4 = _context2.sent;
              _context2.t5 = formDataFlatten.email.toLowerCase();
              _context2.next = 21;
              return this.hash(formDataFlatten.email.toLowerCase());
            case 21:
              _context2.t6 = _context2.sent;
              _context2.t7 = contactReasonSelected;
              _context2.t8 = formDataFlatten.dealer && formDataFlatten.dealer.split('|')[2] ? formDataFlatten.dealer.split('|')[2].toLowerCase() : null;
              _context2.t9 = {
                name_form: _context2.t1,
                name_form_sha: _context2.t2,
                phone_form: _context2.t3,
                phone_form_sha: _context2.t4,
                email_form: _context2.t5,
                email_form_sha: _context2.t6,
                contact_reason: _context2.t7,
                vehicle_type: 'car',
                brand: 'mitsubishi',
                product_condition: 'new',
                model: null,
                dealer_name: _context2.t8,
                gender: null
              };
              _context2.t10 = {
                event: 'contact_form_steps',
                comp_page: _context2.t9
              };
              _context2.t0.push.call(_context2.t0, _context2.t10);
            case 27:
              if (!(data.leadFormType.toLowerCase() === 'book-a-test-drive')) {
                _context2.next = 49;
                break;
              }
              model = this.carSelectorData && this.carSelectorData.productTile.find(function (e) {
                return e.code + "_" + e.year === formDataFlatten.vehicle;
              });
              customerName = formDataFlatten.firstname + " " + formDataFlatten.lastname;
              if (formDataFlatten.surname) {
                customerName = customerName.concat(" " + formDataFlatten.surname);
              }
              _context2.t11 = window.dataLayer;
              _context2.t12 = model && model.name ? model.name.toLowerCase() : formDataFlatten['chosen-test-drive-vehicle'] && formDataFlatten['chosen-test-drive-vehicle'].toLowerCase() || null;
              _context2.t13 = formDataFlatten.dealer && formDataFlatten.dealer.split('|')[2] ? formDataFlatten.dealer.split('|')[2].toLowerCase() : null;
              _context2.t14 = customerName.toLowerCase();
              _context2.next = 37;
              return this.hash(customerName.toLowerCase());
            case 37:
              _context2.t15 = _context2.sent;
              _context2.t16 = formDataFlatten.phonenumber;
              _context2.next = 41;
              return this.hash(formDataFlatten.phonenumber);
            case 41:
              _context2.t17 = _context2.sent;
              _context2.t18 = formDataFlatten.email.toLowerCase();
              _context2.next = 45;
              return this.hash(formDataFlatten.email.toLowerCase());
            case 45:
              _context2.t19 = _context2.sent;
              _context2.t20 = {
                vehicle_type: 'car',
                brand: 'mitsubishi',
                product_condition: 'new',
                model: _context2.t12,
                version: null,
                fuel_type: null,
                dealer_name: _context2.t13,
                name_form: _context2.t14,
                name_form_sha: _context2.t15,
                phone_form: _context2.t16,
                phone_form_sha: _context2.t17,
                email_form: _context2.t18,
                email_form_sha: _context2.t19,
                step: '1/2'
              };
              _context2.t21 = {
                event: 'test_drive_request_steps',
                comp_product: _context2.t20
              };
              _context2.t11.push.call(_context2.t11, _context2.t21);
            case 49:
              if (!(market.toLowerCase() === 'es' && data.leadFormType.toLowerCase() === 'book-a-service')) {
                _context2.next = 70;
                break;
              }
              _customerName = formDataFlatten.firstname + " " + formDataFlatten.lastname;
              if (formDataFlatten.surname) {
                _customerName = _customerName.concat(" " + formDataFlatten.surname);
              }
              _context2.t22 = window.dataLayer;
              _context2.t23 = formDataFlatten.modelo ? formDataFlatten.modelo.toLowerCase() : null;
              _context2.t24 = formDataFlatten.dealer && formDataFlatten.dealer.split('|')[2] ? formDataFlatten.dealer.split('|')[2].toLowerCase() : null;
              _context2.t25 = _customerName.toLowerCase();
              _context2.next = 58;
              return this.hash(_customerName.toLowerCase());
            case 58:
              _context2.t26 = _context2.sent;
              _context2.t27 = formDataFlatten.phonenumber;
              _context2.next = 62;
              return this.hash(formDataFlatten.phonenumber);
            case 62:
              _context2.t28 = _context2.sent;
              _context2.t29 = formDataFlatten.email.toLowerCase();
              _context2.next = 66;
              return this.hash(formDataFlatten.email.toLowerCase());
            case 66:
              _context2.t30 = _context2.sent;
              _context2.t31 = {
                vehicle_type: 'car',
                brand: 'mitsubishi',
                product_condition: 'new',
                model: _context2.t23,
                version: null,
                fuel_type: null,
                dealer_name: _context2.t24,
                name_form: _context2.t25,
                name_form_sha: _context2.t26,
                phone_form: _context2.t27,
                phone_form_sha: _context2.t28,
                email_form: _context2.t29,
                email_form_sha: _context2.t30,
                step: '1/2'
              };
              _context2.t32 = {
                event: 'maintenance_request_steps',
                comp_product: _context2.t31
              };
              _context2.t22.push.call(_context2.t22, _context2.t32);
            case 70:
              /* NL Enhanced conversion logic */
              if (market.toLowerCase() === 'nl') {
                _formDataFlatten3 = this.flattenArray(formData);
                enhancedConvUserData = {
                  email: _formDataFlatten3 == null ? void 0 : _formDataFlatten3.email
                };
                gtag('set', 'user_data', enhancedConvUserData);
                if (data.leadFormType.toLowerCase() === 'book-a-test-drive') {
                  if (typeof window !== 'undefined' && window.dataLayer) {
                    window.dataLayer = window.dataLayer || [];
                    window.dataLayer.push({
                      vehicleVersion: _formDataFlatten3 == null ? void 0 : _formDataFlatten3.model__c
                    });
                  }
                }
              }
              if (market.toLowerCase() === 'ca' && data.leadFormType.toLowerCase() === 'book-a-test-drive' && typeof window !== 'undefined' && window.dataLayer && !hasErrors) {
                _formDataFlatten4 = this.flattenArray(formData);
                _model = this.carSelectorData && this.carSelectorData.productTile.find(function (e) {
                  return e.code + "_" + e.year === _formDataFlatten4.vehicle;
                });
                mmscan_opt_in = _formDataFlatten4['opt-in-to-mmscan-communication'] === 'opt-in-to-MMSCAN-communication' ? 'yes' : 'no';
                dealer_opt_in = _formDataFlatten4['opt-in-to-dealer-communication'] === 'opt-in-to-dealer-communication' ? 'yes' : 'no';
                dataCollection = {
                  event: 'book_test_drive',
                  nameplate: _model == null ? void 0 : (_model$vehicleModel = _model.vehicleModel) == null ? void 0 : _model$vehicleModel.toLowerCase(),
                  vehicle_year: _model == null ? void 0 : _model.year,
                  vehicle_trim: _model == null ? void 0 : (_model$baseModelCode = _model.baseModelCode) == null ? void 0 : _model$baseModelCode.toLowerCase(),
                  mmscan_opt_in: mmscan_opt_in,
                  dealer_opt_in: dealer_opt_in
                };
                dataCollection = (0, _commonLibs.cleanObject)(dataCollection);
                window.dataLayer.push(dataCollection);
              }
            case 72:
            case "end":
              return _context2.stop();
          }
        }
      }, _callee2, this);
    }));
    function publishFormSubmissionToDataLayer(_x2) {
      return _publishFormSubmissionToDataLayer.apply(this, arguments);
    }
    return publishFormSubmissionToDataLayer;
  }();
  _proto.publishFormCompletedToDataLayer = /*#__PURE__*/function () {
    var _publishFormCompletedToDataLayer = (0, _asyncToGenerator2["default"])(/*#__PURE__*/_regenerator["default"].mark(function _callee3() {
      var _this$props5, market, data, formData, formDataFlatten, formId, _formDataFlatten$chos, lead_id, carModel, contactReasonSelected, model, customerName, _customerName2, carTypeFieldValue, dealerFieldValue;
      return _regenerator["default"].wrap(function _callee3$(_context3) {
        while (1) {
          switch (_context3.prev = _context3.next) {
            case 0:
              _this$props5 = this.props, market = _this$props5.config.market, data = _this$props5.data;
              formData = this.state.formData;
              formDataFlatten = this.flattenArray(formData);
              formId = handleNestedProp(data, 'data.leadFormType');
              if (market.toLowerCase() === 'pt' && typeof window !== 'undefined' && window.dataLayer) {
                lead_id = this.getCookie(LEAD_ID_COOKIE);
                carModel = formDataFlatten['chosen-test-drive-vehicle'] ? (_formDataFlatten$chos = formDataFlatten['chosen-test-drive-vehicle']) == null ? void 0 : _formDataFlatten$chos.toLowerCase() : 'NA';
                window.dataLayer.push({
                  event: "FormSubmissionSuccess",
                  dealer: formDataFlatten.dealer && formDataFlatten.dealer.split('|')[2] ? formDataFlatten.dealer.split('|')[2].toLowerCase() : null,
                  carModel: carModel,
                  type: "NA",
                  price: "NA",
                  formType: formId,
                  pageType: "NA",
                  uniqueD: lead_id
                });
              }
              if (!((market.toLowerCase() === 'es' || market.toLowerCase() === 'pt' || market.toLowerCase() === 'fi') && typeof window !== 'undefined' && window.dataLayer)) {
                _context3.next = 71;
                break;
              }
              window.dataLayer = window.dataLayer || [];
              if (!(formId === 'contact-us')) {
                _context3.next = 28;
                break;
              }
              contactReasonSelected = null;
              if (formDataFlatten.enquiry) {
                contactReasonSelected = formDataFlatten.enquiry.toLowerCase();
              } else if (formDataFlatten.consulta) {
                contactReasonSelected = formDataFlatten.consulta.toLowerCase();
              } else if (formDataFlatten['yhteydenoton-aihe']) {
                contactReasonSelected = formDataFlatten['yhteydenoton-aihe'].toLowerCase();
              }
              _context3.t0 = window.dataLayer;
              _context3.t1 = (formDataFlatten.firstname + " " + formDataFlatten.lastname).toLowerCase();
              _context3.next = 14;
              return this.hash((formDataFlatten.firstname + " " + formDataFlatten.lastname).toLowerCase());
            case 14:
              _context3.t2 = _context3.sent;
              _context3.t3 = formDataFlatten.phonenumber;
              _context3.next = 18;
              return this.hash(formDataFlatten.phonenumber);
            case 18:
              _context3.t4 = _context3.sent;
              _context3.t5 = formDataFlatten.email.toLowerCase();
              _context3.next = 22;
              return this.hash(formDataFlatten.email.toLowerCase());
            case 22:
              _context3.t6 = _context3.sent;
              _context3.t7 = contactReasonSelected;
              _context3.t8 = formDataFlatten.dealer && formDataFlatten.dealer.split('|')[2] ? formDataFlatten.dealer.split('|')[2].toLowerCase() : null;
              _context3.t9 = {
                status: 'ok',
                name_form: _context3.t1,
                name_form_sha: _context3.t2,
                phone_form: _context3.t3,
                phone_form_sha: _context3.t4,
                email_form: _context3.t5,
                email_form_sha: _context3.t6,
                contact_reason: _context3.t7,
                vehicle_type: 'car',
                brand: 'mitsubishi',
                product_condition: 'new',
                model: null,
                dealer_name: _context3.t8,
                gender: null
              };
              _context3.t10 = {
                event: 'contact_form_completed',
                comp_page: _context3.t9
              };
              _context3.t0.push.call(_context3.t0, _context3.t10);
            case 28:
              if (!(formId === 'book-a-test-drive')) {
                _context3.next = 50;
                break;
              }
              model = this.carSelectorData && this.carSelectorData.productTile.find(function (e) {
                return e.code + "_" + e.year === formDataFlatten.vehicle;
              });
              customerName = formDataFlatten.firstname + " " + formDataFlatten.lastname;
              if (formDataFlatten.surname) {
                customerName = customerName.concat(" " + formDataFlatten.surname);
              }
              _context3.t11 = window.dataLayer;
              _context3.t12 = model && model.name ? model.name.toLowerCase() : formDataFlatten['chosen-test-drive-vehicle'] && formDataFlatten['chosen-test-drive-vehicle'].toLowerCase() || null;
              _context3.t13 = formDataFlatten.dealer && formDataFlatten.dealer.split('|')[2] ? formDataFlatten.dealer.split('|')[2].toLowerCase() : null;
              _context3.t14 = customerName.toLowerCase();
              _context3.next = 38;
              return this.hash(customerName.toLowerCase());
            case 38:
              _context3.t15 = _context3.sent;
              _context3.t16 = formDataFlatten.phonenumber;
              _context3.next = 42;
              return this.hash(formDataFlatten.phonenumber);
            case 42:
              _context3.t17 = _context3.sent;
              _context3.t18 = formDataFlatten.email.toLowerCase();
              _context3.next = 46;
              return this.hash(formDataFlatten.email.toLowerCase());
            case 46:
              _context3.t19 = _context3.sent;
              _context3.t20 = {
                vehicle_type: 'car',
                brand: 'mitsubishi',
                product_condition: 'new',
                model: _context3.t12,
                version: null,
                fuel_type: null,
                dealer_name: _context3.t13,
                name_form: _context3.t14,
                name_form_sha: _context3.t15,
                phone_form: _context3.t16,
                phone_form_sha: _context3.t17,
                email_form: _context3.t18,
                email_form_sha: _context3.t19,
                step: '2/2',
                status: 'ok'
              };
              _context3.t21 = {
                event: 'test_drive_request_completed',
                comp_product: _context3.t20
              };
              _context3.t11.push.call(_context3.t11, _context3.t21);
            case 50:
              if (!(market.toLowerCase() === 'es' && formId === 'book-a-service')) {
                _context3.next = 71;
                break;
              }
              _customerName2 = formDataFlatten.firstname + " " + formDataFlatten.lastname;
              if (formDataFlatten.surname) {
                _customerName2 = _customerName2.concat(" " + formDataFlatten.surname);
              }
              _context3.t22 = window.dataLayer;
              _context3.t23 = formDataFlatten.modelo ? formDataFlatten.modelo.toLowerCase() : null;
              _context3.t24 = formDataFlatten.dealer && formDataFlatten.dealer.split('|')[2] ? formDataFlatten.dealer.split('|')[2].toLowerCase() : null;
              _context3.t25 = _customerName2.toLowerCase();
              _context3.next = 59;
              return this.hash(_customerName2.toLowerCase());
            case 59:
              _context3.t26 = _context3.sent;
              _context3.t27 = formDataFlatten.phonenumber;
              _context3.next = 63;
              return this.hash(formDataFlatten.phonenumber);
            case 63:
              _context3.t28 = _context3.sent;
              _context3.t29 = formDataFlatten.email.toLowerCase();
              _context3.next = 67;
              return this.hash(formDataFlatten.email.toLowerCase());
            case 67:
              _context3.t30 = _context3.sent;
              _context3.t31 = {
                vehicle_type: 'car',
                brand: 'mitsubishi',
                product_condition: 'new',
                model: _context3.t23,
                version: null,
                fuel_type: null,
                dealer_name: _context3.t24,
                name_form: _context3.t25,
                name_form_sha: _context3.t26,
                phone_form: _context3.t27,
                phone_form_sha: _context3.t28,
                email_form: _context3.t29,
                email_form_sha: _context3.t30,
                step: '2/2',
                status: 'ok'
              };
              _context3.t32 = {
                event: 'maintenance_request_completed',
                comp_product: _context3.t31
              };
              _context3.t22.push.call(_context3.t22, _context3.t32);
            case 71:
              if (market.toLowerCase() === 'ro' && typeof window !== 'undefined' && window.dataLayer) {
                carTypeFieldValue = formDataFlatten['chosen-test-drive-vehicle'] || formDataFlatten['vehicle-dropdown'] || null;
                dealerFieldValue = formDataFlatten.dealer ? formDataFlatten.dealer.split('|')[2] : null;
                window.dataLayer = window.dataLayer || [];
                window.dataLayer.push({
                  event: 'form_submit',
                  form_name: data.leadFormType && data.leadFormType.toLowerCase() === 'book-a-test-drive' ? 'test drive' : data.leadFormType.toLowerCase() === 'book-a-service' ? 'service' : null,
                  form_field_car_type: carTypeFieldValue,
                  form_field_geo_location: dealerFieldValue
                });
              }
            case 72:
            case "end":
              return _context3.stop();
          }
        }
      }, _callee3, this);
    }));
    function publishFormCompletedToDataLayer() {
      return _publishFormCompletedToDataLayer.apply(this, arguments);
    }
    return publishFormCompletedToDataLayer;
  }();
  _proto.hasHoneyPot = function hasHoneyPot(formData) {
    var _formData$find;
    return (_formData$find = formData.find(function (_ref3) {
      var fieldName = _ref3.fieldName;
      return fieldName === 'honeyPot';
    })) == null ? void 0 : _formData$find.value;
  };
  _proto.setGhostSubmission = function setGhostSubmission() {
    var _this13 = this;
    var _ref4 = this.props || {},
      data = _ref4.data;
    var leadFormType = (data == null ? void 0 : data.leadFormType.toLowerCase()) || '';
    var padding = 220;
    setTimeout(function () {
      safeScrollDocument(document.getElementById("thankyou-" + leadFormType).offsetTop - padding);
    }, 250);
    this.setState(function () {
      return _objectSpread(_objectSpread({}, _this13.state), {}, {
        isGhostSubmission: true
      });
    });
  };
  _proto.formSubmit = function formSubmit(formData, formComponents, mutationFn) {
    var _this14 = this;
    var _this$state = this.state,
      submitted = _this$state.submitted,
      componentData = _this$state.componentData;
    var hasHoneyPotValue = this.hasHoneyPot(formData);
    return function (e) {
      e.preventDefault();
      var _this14$props = _this14.props,
        _this14$props$config = _this14$props.config,
        market = _this14$props$config.market,
        language = _this14$props$config.language,
        path = _this14$props.path,
        pathFromPageSwitch = _this14$props.pathFromPageSwitch;
      var validate = _this14.findNestedData(_this14.validateSubmit(formComponents));

      // Essentially we can use this field to not start building an errors array until /after/ a user tried to submit once
      var errors = formData.map(function (component, idx) {
        if (Array.isArray(component)) {
          return validate(component, idx);
        }
        return _this14.validateSubmit(formComponents)(component, [idx]);
      });
      if (!submitted) {
        _this14.updateHasErrors(errors, _this14.setSubmitted(!errors.includes('error')));
      }

      // We can post the data or not based on whether errors has an indexOf('error') > -1
      // Here if there are errors we need to render the requiredMessage from the componentData, which is a level above where this fn was called from

      var hasErrors = (0, _flattenDeep2["default"])(errors).indexOf('error') > -1;

      // eslint-disable-next-line
      hasErrors ? _this14.updateHasErrors(errors, function () {
        if (typeof window !== 'undefined') {
          window.setTimeout(function () {
            _this14.publishFormSubmissionToDataLayer(hasErrors);
          }, 200);
        }
      }) : _this14.updateHasErrors(errors, function () {
        _this14.setState(function () {
          return {
            mutationError: false
          };
        });
        if (componentData.showRecaptcha && typeof window !== 'undefined' && window.grecaptcha) {
          window.grecaptcha.ready(function () {
            window.grecaptcha.execute(componentData.recaptchaSiteKey, {
              action: 'recaptchaAction'
            }).then(function (token) {
              componentData.recaptchaToken = token;
              document.getElementById('recaptchaResponse').value = token;
              if (!hasHoneyPotValue) {
                mutationFn({
                  variables: _this14.mutationVariables(market, language, path || pathFromPageSwitch, formData)
                });
              } else {
                _this14.setGhostSubmission();
              }
            });
          });
        } else {
          if (!hasHoneyPotValue) {
            mutationFn({
              variables: _this14.mutationVariables(market, language, path || pathFromPageSwitch, formData)
            });
          } else {
            _this14.setGhostSubmission();
          }
        }
        window.setTimeout(function () {
          _this14.publishFormSubmissionToDataLayer(hasErrors);
        }, 200);
      });
    };
  };
  _proto.renderColumnControl = function renderColumnControl(nestedComponent, i) {
    var _this15 = this;
    var _this$props6 = this.props,
      config = _this$props6.config,
      theme = _this$props6.theme;
    var formData = this.state.formData;
    var selectedVehicle = formData[0] && formData[0].fieldName === 'vehicle' ? formData[0].value : '';
    var inquiryForm = this.getInquiryForm(formData);
    var selectedInquiry = this.getSelectedInquiry(inquiryForm);
    return /*#__PURE__*/_react["default"].createElement("div", {
      className: (0, _clsx4["default"])(_constructedForm["default"].columnControlContainer, _constructedForm["default"].formWidth),
      key: i
    }, nestedComponent.columns.map(function (column, j) {
      return /*#__PURE__*/_react["default"].createElement("div", {
        className: _constructedForm["default"].columnContainer,
        key: j
      }, column.components.map(function (comp, k) {
        var FormElement = FORM_ELEMENTS[_this15.checkCompType(comp)];
        var formOptions = comp.showWhenOptionMatches;
        if (!formOptions || formOptions && formOptions.length === 0 || formOptions && formOptions.length > 0 && formOptions.includes(selectedInquiry)) {
          var _clsx;
          return FormElement !== undefined ? /*#__PURE__*/_react["default"].createElement("div", {
            className: (0, _clsx4["default"])(_constructedForm["default"].rowItem, (_clsx = {}, _clsx[_constructedForm["default"].hidden] = (comp == null ? void 0 : comp.inputType) === 'hidden', _clsx)),
            key: k
          }, /*#__PURE__*/_react["default"].createElement(FormElement, {
            key: comp.fieldName + "-" + i + "-" + j + "-" + k,
            theme: theme,
            data: comp,
            value: formData[i][j][k].value,
            id: [i, j, k],
            config: config,
            errorMessages: formData[i][j][k].errors,
            validateAllConstraints: _this15.validateAllConstraints,
            handleFieldChange: _this15.handleFieldChange,
            updateErrors: _this15.updateErrors,
            checkRequired: _this15.checkRequired,
            selectedVehicle: selectedVehicle
          })) : /*#__PURE__*/_react["default"].createElement("div", {
            key: "empty-" + i + "-" + j + "-" + k,
            className: _constructedForm["default"].rowItem
          });
        }
        return null;
      }));
    }));
  };
  _proto.renderCarSelector = function renderCarSelector() {
    var _this$props7 = this.props,
      theme = _this$props7.theme,
      requiredMessage = _this$props7.data.requiredMessage;
    var formData = this.state.formData;
    var formElement = formData.find(function (element) {
      return element.fieldName === 'vehicle';
    });
    return this.carSelectorData && /*#__PURE__*/_react["default"].createElement(_homepageCarSelector.HomepageCarSelector, {
      handleChangeEvent: this.handleFieldChange,
      selectedValue: formElement.value,
      position: formElement.pos,
      updateErrors: this.updateErrors,
      requiredMessage: requiredMessage,
      errorMessages: formElement.errors,
      data: this.carSelectorData,
      theme: theme
    });
  };
  _proto.renderSelectedCarSection = function renderSelectedCarSection(selectedVehicle, thankYouMessage, formComponent, theme) {
    var config = this.props.config;
    var vehiclePrice = selectedVehicle.price;
    var vehicleImage = selectedVehicle.vehicleImage.image;
    var _formComponent$ = formComponent[0],
      disclaimerData = _formComponent$.disclaimerData,
      addPriceDisclaimer = _formComponent$.addPriceDisclaimer,
      priceDisclaimerId = _formComponent$.priceDisclaimerId;
    return /*#__PURE__*/_react["default"].createElement("div", {
      className: _constructedForm["default"].selectedCarSection
    }, /*#__PURE__*/_react["default"].createElement("div", {
      className: _constructedForm["default"].selectedCarText
    }, /*#__PURE__*/_react["default"].createElement("h3", null, thankYouMessage.title), /*#__PURE__*/_react["default"].createElement("p", {
      className: theme.introCopy
    }, selectedVehicle.name), /*#__PURE__*/_react["default"].createElement(_commonI18n.CommonI18N, {
      format: "price",
      options: {
        value: vehiclePrice.value,
        currency: handleNestedProp(config, 'config.currencyFormat'),
        displayValue: vehiclePrice.displayValue,
        locale: handleNestedProp(config, 'config.localeCode')
      },
      addPriceDisclaimer: addPriceDisclaimer,
      priceDisclaimerId: priceDisclaimerId,
      disclaimerData: disclaimerData
    })), /*#__PURE__*/_react["default"].createElement("img", {
      src: vehicleImage,
      alt: vehicleImage.altText
    }));
  };
  _proto.renderSelectedDealerSection = function renderSelectedDealerSection(selectedDealer, thankYouMessage) {
    var _this16 = this;
    var market = this.props.config.market;
    var dealerDetails = selectedDealer.map(function (dealer) {
      return _this16.makeDealerDetails(dealer);
    });
    return /*#__PURE__*/_react["default"].createElement("div", {
      className: _constructedForm["default"].selectedDealerSection
    }, market.toLowerCase() === 'us' && (_h || (_h = /*#__PURE__*/_react["default"].createElement("h4", null, "Your request has been sent to:"))), /*#__PURE__*/_react["default"].createElement("div", {
      className: _constructedForm["default"].selectedDealerDetails
    }, dealerDetails.map(function (dealer) {
      return /*#__PURE__*/_react["default"].createElement("div", {
        className: _constructedForm["default"].selectedDealer
      }, /*#__PURE__*/_react["default"].createElement("p", {
        className: _constructedForm["default"].dealerHeading
      }, dealer.dealerName), /*#__PURE__*/_react["default"].createElement("p", {
        className: _constructedForm["default"].dealerDetails
      }, (dealer.dealerAddress ? dealer.dealerAddress : '') + "\n" + (dealer.dealerPhone ? dealer.dealerPhone : '') + "\n", dealer.dealerUrl && /*#__PURE__*/_react["default"].createElement("a", {
        href: dealer.dealerUrl,
        target: "_blank",
        rel: "noopener noreferrer"
      }, dealer.dealerUrl.replace('https://www.', ''))));
    })), /*#__PURE__*/_react["default"].createElement("p", null, thankYouMessage.text));
  };
  _proto.renderThankYouMessage = function renderThankYouMessage(selectedVehicle, selectedDealer, thankYouMessage, theme, formComponent) {
    if (selectedVehicle === void 0) {
      selectedVehicle = null;
    }
    if (selectedDealer === void 0) {
      selectedDealer = null;
    }
    return /*#__PURE__*/_react["default"].createElement("div", {
      className: _constructedForm["default"].thankYouSection
    }, selectedVehicle !== null ? this.renderSelectedCarSection(selectedVehicle, thankYouMessage, formComponent, theme) : null, selectedDealer !== null ? this.renderSelectedDealerSection(selectedDealer, thankYouMessage) : null);
  };
  _proto.renderThankYouSection = function renderThankYouSection() {
    var theme = this.props.theme;
    var _this$state2 = this.state,
      _this$state2$componen = _this$state2.componentData,
      formComponents = _this$state2$componen.formComponents,
      thankYouMessage = _this$state2$componen.thankYouMessage,
      CTAs = _this$state2$componen.CTAs,
      selectedVehicle = _this$state2$componen.selectedVehicle,
      selectedDealer = _this$state2$componen.selectedDealer,
      _this$state2$componen2 = _this$state2$componen.leadFormType,
      leadFormType = _this$state2$componen2 === void 0 ? '' : _this$state2$componen2,
      registerAgainLabel = _this$state2$componen.registerAgainLabel,
      backgroundColour = _this$state2$componen.backgroundColour,
      formData = _this$state2.formData;
    var data = this.props.data;
    var isNewsLetterSignUpForm = leadFormType.indexOf('newsletter-signup') >= 0 || leadFormType.indexOf('outlander-prelaunch-signup') >= 0 || leadFormType.indexOf('abonnez-vous-a-bulletin') >= 0;
    var isBackgroundColorDark = backgroundColour === 'dark';
    var registerAgainButtonTheme = isNewsLetterSignUpForm && isBackgroundColorDark;
    var formId = handleNestedProp(data, 'data.leadFormType');
    setTimeout(this.publishFormCompletedToDataLayer, 0);
    return /*#__PURE__*/_react["default"].createElement("div", {
      className: "" + _constructedForm["default"].thankYouOuter,
      "data-theme": backgroundColour,
      "data-form-type": leadFormType,
      id: formId
    }, /*#__PURE__*/_react["default"].createElement("div", {
      className: _constructedForm["default"].thankYouWidth + " " + _constructedForm["default"].thankYouInner
    }, thankYouMessage.eyebrowText && /*#__PURE__*/_react["default"].createElement("p", {
      className: theme.labelMedium
    }, thankYouMessage.eyebrowText), !selectedVehicle && /*#__PURE__*/_react["default"].createElement("h1", {
      className: theme.headingThree + " " + _constructedForm["default"].thankYouTitle
    }, handleNestedProp(thankYouMessage, 'thankYouMessage.title')), (selectedVehicle !== undefined || selectedDealer !== undefined) && this.renderThankYouMessage(selectedVehicle, selectedDealer, thankYouMessage, theme, formComponents), this.checkForDocumentCard(formData, theme), selectedDealer === undefined ? /*#__PURE__*/_react["default"].createElement("div", {
      className: _constructedForm["default"].thankYouTextWrapper
    }, /*#__PURE__*/_react["default"].createElement("p", {
      className: theme.bodyCopy,
      dangerouslySetInnerHTML: {
        __html: handleNestedProp(thankYouMessage, 'thankYouMessage.text')
      }
    })) : null, thankYouMessage.caption && /*#__PURE__*/_react["default"].createElement("p", {
      className: theme.bodyCopy + " " + _constructedForm["default"].thankYouMessageCaption
    }, thankYouMessage.caption), registerAgainLabel && /*#__PURE__*/_react["default"].createElement(_commonCta.CommonCta, {
      theme: theme,
      data: {
        label: registerAgainLabel,
        priority: isNewsLetterSignUpForm ? 'low' : 'medium'
      },
      clickEvent: this.handleClickRegisterAgain,
      classes: [_constructedForm["default"].newsletterRegisterBtn, registerAgainButtonTheme ? theme.dark : '']
    }), CTAs && CTAs.length > 0 && /*#__PURE__*/_react["default"].createElement(_ctaRow.CtaRow, {
      theme: theme,
      data: {
        CTAs: CTAs
      }
    })));
  };
  _proto.renderFormElement = function renderFormElement(component, idx) {
    var _this$props8 = this.props,
      config = _this$props8.config,
      theme = _this$props8.theme,
      path = _this$props8.path,
      data = _this$props8.data;
    var _this$state3 = this.state,
      componentData = _this$state3.componentData,
      formData = _this$state3.formData,
      formError = _this$state3.formError;
    var requiredMessage = componentData.requiredMessage;
    var isFormError = (0, _flattenDeep2["default"])(formError).indexOf('error') > -1;
    var FormElement = FORM_ELEMENTS[this.checkCompType(component)];
    var selectedVehicle = formData[0] && formData[0].fieldName === 'vehicle' ? formData[0].value : '';
    var inquiryForm = this.getInquiryForm(formData);
    var selectedInquiry = this.getSelectedInquiry(inquiryForm);
    var formOptions = component.showWhenOptionMatches;
    var isCa = config.market.toLowerCase() === 'ca';
    var leadFormType = data.leadFormType.toLowerCase() || '';
    var isNewsLetterSignUp = leadFormType.indexOf('newsletter-signup') >= 0 || leadFormType.indexOf('outlander-prelaunch-signup') >= 0 || leadFormType.indexOf('abonnez-vous-a-bulletin') >= 0;
    if (!formOptions || formOptions && formOptions.length === 0 || formOptions && formOptions.length > 0 && formOptions.includes(selectedInquiry)) {
      var _clsx2;
      return FormElement !== undefined && /*#__PURE__*/_react["default"].createElement("div", {
        className: (0, _clsx4["default"])(_constructedForm["default"].formWidth, _constructedForm["default"][component.fieldName], (_clsx2 = {}, _clsx2[_constructedForm["default"].miniDealerLocatorPadding] = component.resourceType === 'MiniDealerLocator_1_0_0', _clsx2))
      }, /*#__PURE__*/_react["default"].createElement(FormElement, {
        key: component.fieldName + "-" + idx,
        formError: {
          isError: isFormError,
          message: requiredMessage
        },
        config: config,
        theme: theme,
        data: component,
        value: formData[idx].value,
        id: [idx],
        errorMessages: formData[idx].errors,
        validateAllConstraints: this.validateAllConstraints,
        handleFieldChange: this.handleFieldChange,
        updateErrors: this.updateErrors,
        checkRequired: this.checkRequired,
        requiredMessage: requiredMessage,
        selectedVehicle: selectedVehicle,
        path: path,
        isCaNewsLetterSignUp: isCa && isNewsLetterSignUp,
        backgroundColour: data.backgroundColour,
        fullWidth: component.resourceType === 'TextBlock_1_0_0'
      }));
    }
  };
  _proto.renderFormComponent = function renderFormComponent(component, idx) {
    var resourceType = component.resourceType;
    if (resourceType === 'FormColumnControl_1_0_0') {
      return this.renderColumnControl(component, idx);
    }
    if (resourceType === 'CarSelector_1_0_0') {
      return this.renderCarSelector();
    }
    return this.renderFormElement(component, idx);
  };
  _proto.renderConstructedForm = function renderConstructedForm(sendFormData, loading) {
    var _this17 = this,
      _clsx3;
    var _this$props9 = this.props,
      theme = _this$props9.theme,
      className = _this$props9.className,
      market = _this$props9.config.market,
      data = _this$props9.data;
    var _this$state4 = this.state,
      componentData = _this$state4.componentData,
      formData = _this$state4.formData,
      formError = _this$state4.formError,
      submitted = _this$state4.submitted,
      mutationError = _this$state4.mutationError,
      mutationSuccess = _this$state4.mutationSuccess,
      isGhostSubmission = _this$state4.isGhostSubmission;
    var inquiryForm = this.getInquiryForm(formData);
    var selectedInquiry = this.getSelectedInquiry(inquiryForm);
    var formComponents = componentData.formComponents,
      requiredMessage = componentData.requiredMessage,
      buttonLabel = componentData.buttonLabel,
      errorMessage = componentData.errorMessage,
      submitInfo = componentData.submitInfo,
      backgroundColour = componentData.backgroundColour,
      formAlignment = componentData.formAlignment,
      buttonAlignment = componentData.buttonAlignment,
      validationMessageLabel = componentData.validationMessageLabel;
    var formId = handleNestedProp(componentData, 'componentData.leadFormType');
    var mrkt = market.toLowerCase();
    var isCA = mrkt === 'ca';
    var isUS = mrkt === 'us';
    var leadFormType = data.leadFormType.toLowerCase() || '';
    var isNewsLetterSignUp = leadFormType.indexOf('newsletter-signup') >= 0 || leadFormType.indexOf('outlander-prelaunch-signup') >= 0 || leadFormType.indexOf('abonnez-vous-a-bulletin') >= 0;
    var isFormValid = false;
    var hasErrorOnRequiredField = false;
    var flattenFormData = (0, _flattenDeep2["default"])(formData);
    var requiredFormFields = flattenFormData.filter(function (item) {
      return item.required && !_this17.hasValue(item.value);
    });
    if (requiredFormFields.filter(function (item) {
      return item.showWhenOptionMatches !== undefined;
    })) {
      requiredFormFields = requiredFormFields.filter(function (item) {
        var _item$showWhenOptionM;
        return (_item$showWhenOptionM = item.showWhenOptionMatches) != null && _item$showWhenOptionM.length ? item.showWhenOptionMatches.includes(selectedInquiry) : true;
      });
    }
    var requiredButInvalidFormFields = flattenFormData.filter(function (item) {
      return item.required && item.errors[0] === 'requiredMessage';
    });
    isFormValid = !(requiredFormFields.length > 0);
    hasErrorOnRequiredField = requiredButInvalidFormFields.length > 0;
    var isFormError = (0, _flattenDeep2["default"])(formError).indexOf('error') > -1;
    return /*#__PURE__*/_react["default"].createElement("form", {
      ref: this.formRef,
      "data-theme": backgroundColour,
      "data-formalignment": formAlignment,
      "data-buttonalignment": buttonAlignment,
      className: (0, _clsx4["default"])(className, (_clsx3 = {}, _clsx3[_constructedForm["default"].formMargin] = !this.carSelectorData, _clsx3[_constructedForm["default"].carSelectorFormMargin] = this.carSelectorData, _clsx3[_constructedForm["default"].isNewsLetterSignUpMargin] = isNewsLetterSignUp, _clsx3)),
      automation: "forms",
      onSubmit: this.formSubmit(formData, formComponents, sendFormData),
      noValidate: true,
      id: isUS && isNewsLetterSignUp ? formId + "-us" : formId,
      autoComplete: "nonOffString"
    }, /*#__PURE__*/_react["default"].createElement("div", {
      id: "anchor",
      className: _constructedForm["default"].anchorClass
    }), componentData.leadFormDescription && /*#__PURE__*/_react["default"].createElement("div", {
      className: (0, _clsx4["default"])(theme.row, _constructedForm["default"].formTitleContainer, _constructedForm["default"].formWidth)
    }, /*#__PURE__*/_react["default"].createElement("h2", {
      className: "" + theme['col-xs-12']
    }, componentData.leadFormDescription)), /*#__PURE__*/_react["default"].createElement("div", {
      className: (0, _clsx4["default"])(theme.row, _constructedForm["default"].formComponentsContainer)
    }, /*#__PURE__*/_react["default"].createElement("div", {
      className: (0, _clsx4["default"])(theme['col-xs-12'], theme['col-sm-12'], _constructedForm["default"].fieldSetContainer)
    }, /*#__PURE__*/_react["default"].createElement("fieldset", {
      disabled: submitted && mutationSuccess && !mutationError && !isFormError || isGhostSubmission,
      className: _constructedForm["default"].formFieldSet
    }, /*#__PURE__*/_react["default"].createElement("div", {
      className: "" + _constructedForm["default"].formComponentsWrapper
    }, formComponents && formComponents.map(function (component, i) {
      return _this17.renderFormComponent(component, i);
    })), !loading && !isFormError && submitted && mutationError && /*#__PURE__*/_react["default"].createElement("div", {
      className: (0, _clsx4["default"])(_constructedForm["default"].serverError, _constructedForm["default"].formWidth)
    }, /*#__PURE__*/_react["default"].createElement(_errorMessage["default"], {
      message: errorMessage,
      theme: theme,
      role: "alert",
      errorLabel: errorMessage
    })), submitInfo && /*#__PURE__*/_react["default"].createElement("div", {
      className: (0, _clsx4["default"])(_constructedForm["default"].submitInfoWrapper, _constructedForm["default"].formWidth)
    }, submitInfo.map(function (info) {
      var realKey = generateRandomNumber();
      return /*#__PURE__*/_react["default"].createElement(_commonRichText.CommonRichText, {
        key: realKey,
        html: info,
        theme: theme,
        className: _constructedForm["default"].submitInfo
      });
    })), /*#__PURE__*/_react["default"].createElement(_formButton["default"], {
      theme: theme,
      data: {
        type: 'submit',
        label: buttonLabel,
        fieldName: buttonLabel
      },
      formError: {
        isError: isFormError,
        message: requiredMessage
      },
      loading: loading,
      disabled: submitted && mutationSuccess && !mutationError && !isFormError || !submitted && !isFormValid,
      submitted: submitted,
      isFormValid: isFormValid,
      backgroundColour: backgroundColour,
      isCaNewsLetterSignUp: isCA && isNewsLetterSignUp,
      validationMessageLabel: validationMessageLabel,
      hasErrorOnRequiredField: hasErrorOnRequiredField
    })))), componentData.showRecaptcha && /*#__PURE__*/_react["default"].createElement("span", {
      className: _constructedForm["default"].formWidth
    }, _input || (_input = /*#__PURE__*/_react["default"].createElement("input", {
      type: "hidden",
      name: "recaptchaResponse",
      id: "recaptchaResponse"
    }))));
  };
  _proto.render = function render() {
    var _this18 = this;
    var _this$props10 = this.props,
      theme = _this$props10.theme,
      currentPath = _this$props10.currentPath,
      market = _this$props10.config.market,
      data = _this$props10.data;
    var _this$state5 = this.state,
      componentData = _this$state5.componentData,
      formData = _this$state5.formData,
      formError = _this$state5.formError,
      submitted = _this$state5.submitted,
      mutationError = _this$state5.mutationError,
      mutationSuccess = _this$state5.mutationSuccess,
      isGhostSubmission = _this$state5.isGhostSubmission;
    var formComponents = componentData.formComponents,
      confirmationPixel = componentData.confirmationPixel;
    var mrkt = market.toLowerCase();
    var isCA = mrkt === 'ca';
    var leadFormType = data.leadFormType.toLowerCase() || '';
    var isNewsLetterSignUp = leadFormType.indexOf('newsletter-signup') >= 0 || leadFormType.indexOf('outlander-prelaunch-signup') >= 0 || leadFormType.indexOf('abonnez-vous-a-bulletin') >= 0;
    var isFormError = (0, _flattenDeep2["default"])(formError).indexOf('error') > -1;
    if (leadFormType === 'vehicletabs') {
      return /*#__PURE__*/_react["default"].createElement(_vehicleTabs["default"], {
        components: formComponents,
        theme: theme,
        selectedVehicle: formData[0].value[0]
      });
    }
    var padding = 220;
    var hasDataLayer = typeof window !== 'undefined' && window.dataLayer;
    return /*#__PURE__*/_react["default"].createElement(_aboveTheFoldOnlyServerRender.AboveTheFoldOnlyServerRender, null, /*#__PURE__*/_react["default"].createElement(_reactApollo.Mutation, {
      mutation: SEND_FORM_DATA,
      onError: function onError() {
        return _this18.setState(function () {
          return {
            mutationError: true
          };
        });
      } // eslint-disable-next-line
      ,
      onCompleted: function onCompleted(data) {
        // eslint-disable-next-line
        if (data.submitForm.statusCode !== 200) {
          _this18.setState(function () {
            return {
              mutationError: true
            };
          });
        } else {
          _this18.setState(function () {
            return {
              mutationError: false,
              mutationSuccess: true
            };
          });
          safeScrollDocument(document.getElementById("thankyou-" + leadFormType).offsetTop - padding); // eslint-disable-line

          if (confirmationPixel && _this18.leadTrackingRef) {
            var pixelMarkup = document.createRange().createContextualFragment(confirmationPixel);
            _this18.leadTrackingRef.current.innerHTML = '';
            _this18.leadTrackingRef.current.appendChild(pixelMarkup);
          }
        }
      }
    }, function (sendFormData, _ref5) {
      var loading = _ref5.loading;
      return /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, isNewsLetterSignUp && submitted ? _this18.renderThankYouSection({
        isCA: isCA,
        isNewsLetterSignUp: isNewsLetterSignUp
      }) : _this18.renderConstructedForm(sendFormData, loading), /*#__PURE__*/_react["default"].createElement("div", {
        id: "thankyou-" + leadFormType,
        className: _constructedForm["default"].anchorClass
      }), confirmationPixel && /*#__PURE__*/_react["default"].createElement("div", {
        ref: _this18.leadTrackingRef,
        className: _constructedForm["default"].elementInvisible
      }), submitted && mutationSuccess && !mutationError && !isFormError && !isNewsLetterSignUp && _this18.renderThankYouSection({
        isCA: isCA,
        isNewsLetterSignUp: isNewsLetterSignUp
      }), !submitted && isGhostSubmission && _this18.renderThankYouSection({
        isCA: isCA,
        isNewsLetterSignUp: isNewsLetterSignUp
      }));
    }));
  };
  return ConstructedForm;
}(_react["default"].Component);
ConstructedForm.displayName = 'ConstructedForm';
ConstructedForm.defaultProps = {
  data: _constructedForm2["default"],
  defaultData: _constructedForm2["default"],
  theme: {}
};
var mapStateToProps = function mapStateToProps(state) {
  return {
    config: state.Config
  };
};
var _default = (0, _reactRedux.connect)(mapStateToProps)((0, _reactRouter.withRouter)(ConstructedForm));
exports["default"] = _default;